import './dropdown.less';
import { Dropdown } from 'antd';
import ButtonML from '@/components/button_ml/ButtonML';
const DropDown = (props) => {
  const { menu, btnVal, onVisibleChange, disabled } = props || {};
  return (
    <Dropdown
      overlay={menu}
      onVisibleChange={onVisibleChange}
      disabled={disabled}
    >
      <span>
        <ButtonML size="large" value={btnVal} downIcon={true} />
      </span>
    </Dropdown>
  );
};

export default DropDown;
